// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"67":"0d597ceb","610":"496c2c48","696":"6c4817fc","800":"1de360df"}[chunkId] + ".css";
};